<div class="bannerback">
  <app-nav></app-nav>
</div>
<div *ngIf="loading" style="width: 100%;height: 70vh;" class="d-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<app-no-data *ngIf="isArray(survey) && !loading"></app-no-data>
<div *ngIf="!loading && !isArray(survey)" class="container-fluid custom-bg">
  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  <div class="container py-5 max-w-1000">
    <div class="">
      <h2 class="font-600 bottom-line color p-0">Survey Results</h2>
    </div>
    <div class="d-flex justify-content-center col-md-12 col-12">
      <div class="card user-details-card">
        <ng-container *ngIf="survey.user != null && survey.user != undefined;else emailOnlyTemplate">
          <div class="d-flex align-items-baseline">
            <i class="pi pi-pencil icon-uii"></i>
            <h6 class="title">Name</h6> &nbsp;:&nbsp; <span class="desc">{{getName(survey.user.name)}}</span>
          </div>
          <div class="d-flex align-items-baseline">
            <i class="pi pi-envelope icon-uii"></i>
            <h6 class="title">E-mail</h6> &nbsp;:&nbsp; <span class="desc">{{survey.user.email}}</span>
          </div>
          <!-- <div class="d-flex align-items-baseline">
            <i class="pi pi-id-card icon-uii"></i>
            <h6 class="title">CNIC</h6> &nbsp;:&nbsp; <span class="desc">{{survey.user.national_id}}</span>
          </div> -->
          <div class="d-flex align-items-baseline">
            <i class="pi pi-mobile icon-uii"></i>
            <h6 class="title">Ph-No</h6> &nbsp;:&nbsp; <span class="desc">{{survey.user.phone}}</span>
          </div>
          <div class="d-flex align-items-baseline">
            <i class="pi pi-users icon-uii"></i>
            <h6 class="title">Gender</h6> &nbsp;:&nbsp; <span class="desc">{{survey.user.gender}}</span>
          </div>
        </ng-container>
        <ng-template #emailOnlyTemplate>
          <div class="d-flex align-items-baseline">
            <i class="pi pi-envelope icon-uii"></i>
            <h6 class="title">E-mail</h6> &nbsp;:&nbsp; <span class="desc">{{survey.email}}</span>
          </div>
        </ng-template>
        <div class="w-100 mx-1 hr-ui"></div>

        <div class="container-fluid p-0">
          <!--  -->
          <ng-container *ngFor="let question of survey.questions">
            <app-question-template [disabled]="true" [question]="question"></app-question-template>
          </ng-container>

          <!-- simple text -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer"> وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال ويتلذذ بالآلام، الألم هو الألم
                      ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100 mx-1 hr-ui"></div>
          </div> -->
          <!-- simple text end -->

          <!-- select single img -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم
                      عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال
                      ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row">
                <label class="img-selector-ui">
                  <span class="d-flex flex-column align-items-center justify-content-center">
                    <i class="pi pi-image selector-icn"></i>
                    <ng-template #imageTemplate>
                      <img
                        src="https://images.unsplash.com/photo-1682686581221-c126206d12f0?auto=format&fit=crop&q=60&w=500&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHx8"
                        alt="question image" />
                    </ng-template>
                    <input type="file" class="form-control inputboxy" dir="rtl" placeholder="Survey Image" />
                    <input
                      style="background-color:transparent;text-align: center; border: none; border-bottom: solid 1px lightgrey; border-radius: 0px; width:100%;"
                      class="input-field p-0" type="text" pInputText />
                  </span>
                </label>
              </div>
            </div>
            <div class="w-100 mx-1 hr-ui"></div>
          </div> -->
          <!-- select single img End -->

          <!-- select many img -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم
                      عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال
                      ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row">
                <label class="img-selector-ui">
                  <span class="d-flex flex-column align-items-center justify-content-center">
                    <i class="pi pi-image selector-icn"></i>
                    <ng-template #imageTemplate>
                      <img
                        src="https://images.unsplash.com/photo-1682686581221-c126206d12f0?auto=format&fit=crop&q=60&w=500&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHx8"
                        alt="question image" />
                    </ng-template>
                    <input type="file" class="form-control inputboxy" dir="rtl" placeholder="Survey Image" />
                    <input
                      style="background-color:transparent;text-align: center; border: none; border-bottom: solid 1px lightgrey; border-radius: 0px; width:100%;"
                      class="input-field p-0" type="text" pInputText />

                  </span>
                </label>
                <label class="img-selector-ui">
                  <span class="d-flex flex-column align-items-center justify-content-center">
                    <i class="pi pi-image selector-icn"></i>
                    <ng-template #imageTemplate>
                      <img
                        src="https://images.unsplash.com/photo-1682686581221-c126206d12f0?auto=format&fit=crop&q=60&w=500&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHx8"
                        alt="question image" />
                    </ng-template>
                    <input type="file" class="form-control inputboxy" dir="rtl" placeholder="Survey Image" />
                    <input
                      style="background-color:transparent;text-align: center; border: none; border-bottom: solid 1px lightgrey; border-radius: 0px; width:100%;"
                      class="input-field p-0" type="text" pInputText />

                  </span>
                </label>
              </div>
            </div>
            <div class="w-100 mx-1 hr-ui"></div>
          </div> -->
          <!-- select many img End -->

          <!-- rating stars -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم
                      عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال
                      ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
              <div class="mx-2">
                <div class="d-flex flex-wrap my-2">
                  <p-rating [disabled]="false" [cancel]="false"></p-rating>
                </div>
                <div class="d-flex flex-wrap my-2">
                  <p-rating [disabled]="false" [cancel]="false"></p-rating>
                </div>
              </div>
            </div>
            <div class="w-100 mx-1 hr-ui"></div>
          </div> -->
          <!-- rating stars end -->

          <!-- smiley emojee -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم
                      عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال
                      ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
              <div class="mx-2">
                <div class="column rating-bg">
                  <span>
                    <img class="rating-width" src="../../assets/rating/s-5.svg" alt="loading">
                  </span>
                  <span class="desc mt-2">السعاده فيما</span>
                </div>
              </div>
            </div>
            <div class="w-100 mx-1 hr-ui"></div>
          </div> -->
          <!-- smiley emojee end -->

          <!-- grid -->
          <!-- <div class="column">
            <div class="my-5">
              <div class="input-with-button column flex-row">
                <div class="w-100">
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-question-circle"></i>
                    <div class="Question">?لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد
                      الألم
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="Q-A pi pi-pencil"></i>
                    <div class="Answer">لكن لا بد أن أوضح لك أن كل هذه الأفكار المغلوطة حول استنكار النشوة وتمجيد الألم
                      عقلانية ومنطقية فيعرضهم هذا لمواجهة الظروف الأليمة، وأكرر بأنه لا يوجد من يرغب في الحب ونيل المنال
                      ويتلذذ بالآلام، الألم هو الألم ولكن نتيجة لظروف ما قد تكمن السعاده فيما نتحمله من كد وأسي.</div>
                  </div>
                </div>
              </div>
              <div class="mx-2">
                <div class="row my-2">
                  <div class="col-md-4 col-12">
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="desc">Column 1</span>
                  </div>

                  <div class="col-md-4 col-12">
                    <span class="desc">Column 2</span>
                  </div>
                </div>
                <div class="row py-2 my-2 grid-row-ui">
                  <div class="col-md-4 col-12">
                    <span class="title">Row 1</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                  </div>

                  <div class="col-md-4 col-12">
                    <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                  </div>
                </div>
              </div>
              <div class="w-100 mx-1 hr-ui"></div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>




<app-footer></app-footer>